import {
  CURRENT_LOCALE,
  IMAGE_SIZES_FOR_BIG_LOGO_WITH_SEPARATED_TEXT,
  IS_HEBREW,
  IS_LOGO_TEXT_SEPARATED,
  LOGO_IMAGE_PROPS,
  LOGO_IMAGE_SIZES,
  LOGO_SRC,
  LogoSize,
} from 'src/constants';

export const getLogoImageProps = (size: LogoSize) => {
  const { big, medium, small } = LOGO_IMAGE_SIZES[CURRENT_LOCALE];

  if (size === LogoSize.BIG) {
    if (IS_LOGO_TEXT_SEPARATED) {
      return {
        ...IMAGE_SIZES_FOR_BIG_LOGO_WITH_SEPARATED_TEXT,
        src: LOGO_SRC.small,
      };
    }

    return {
      height: big.height,
      src: LOGO_SRC.big,
      width: big.width,
    };
  }

  if (IS_LOGO_TEXT_SEPARATED || size === LogoSize.SMALL) {
    return {
      height: small.height,
      src: LOGO_SRC.small,
      width: small.width,
    };
  }

  const { height, width } = medium;

  if (LOGO_IMAGE_PROPS && !IS_HEBREW) {
    return {
      height: LOGO_IMAGE_PROPS.height ?? height,
      src: LOGO_IMAGE_PROPS.src
        ? `${process.env.PUBLIC_URL}${LOGO_IMAGE_PROPS.src}`
        : LOGO_SRC.medium,
      width: LOGO_IMAGE_PROPS.width ?? width,
    };
  }

  if (IS_HEBREW) {
    return {
      height,
      src: LOGO_SRC.medium,
      width,
    };
  }

  return {
    src: LOGO_SRC.medium,
  };
};
